// PWA Installation Prompt Utility
let deferredPrompt = null;
let installButton = null;

// Listen for beforeinstallprompt event
window.addEventListener('beforeinstallprompt', (e) => {
  // ...existing code...
  // Prevent the mini-infobar from appearing on mobile
  e.preventDefault();
  // Stash the event so it can be triggered later
  deferredPrompt = e;
  
  // Show install button if it exists
  if (installButton) {
    installButton.style.display = 'block';
  }
  
  // Dispatch custom event for components to listen
  window.dispatchEvent(new CustomEvent('pwa-installable', {
    detail: { canInstall: true }
  }));
});

// Listen for app installed event
window.addEventListener('appinstalled', () => {
  // ...existing code...
  deferredPrompt = null;
  
  // Hide install button if it exists
  if (installButton) {
    installButton.style.display = 'none';
  }
  
  // Dispatch custom event for components to listen
  window.dispatchEvent(new CustomEvent('pwa-installed', {
    detail: { installed: true }
  }));
});

// Function to show the install prompt
export const showInstallPrompt = async () => {
  if (!deferredPrompt) {
    // ...existing code...
    return false;
  }
  
  try {
    // Show the install prompt
    deferredPrompt.prompt();
    
    // Wait for the user to respond to the prompt
    const { outcome } = await deferredPrompt.userChoice;
    // ...existing code...
    
    // Clear the deferred prompt variable
    deferredPrompt = null;
    
    // Hide install button if it exists
    if (installButton) {
      installButton.style.display = 'none';
    }
    
    return outcome === 'accepted';
  } catch (error) {
    // ...existing code...
    return false;
  }
};

// Function to check if PWA is installable
export const isInstallable = () => {
  return !!deferredPrompt;
};

// Function to check if running as PWA
export const isPWA = () => {
  return window.matchMedia('(display-mode: standalone)').matches ||
         window.navigator.standalone === true ||
         document.referrer.includes('android-app://');
};

// Function to register install button
export const registerInstallButton = (button) => {
  installButton = button;
  
  // Hide button initially if not installable
  if (!deferredPrompt) {
    button.style.display = 'none';
  }
  
  // Add click handler
  button.addEventListener('click', async () => {
    const installed = await showInstallPrompt();
    if (installed) {
      // ...existing code...
    }
  });
};

// Function to get PWA install status
export const getPWAStatus = () => {
  return {
    isInstallable: isInstallable(),
    isInstalled: isPWA(),
    isSupported: 'serviceWorker' in navigator && 'beforeinstallprompt' in window
  };
};